import { Card } from '@auviknetworks/iceberg-ui';
import React from 'react';

export const CustomCard = ({
    children,
    noPadding = false
}: {
    children: React.ReactNode;
    noPadding?: boolean;
}) => (
    <Card sx={{ marginBottom: '24px', padding: noPadding ? '0' : '24px' }}>
        {children}
    </Card>
);
